<template>
	<img :src="src" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  url?: string
  width: number
  height: number
  fallback?: string
}>();

const src = computed(() => {
  if (!props.url) {
    return props.fallback || '';
  }

  const newURL = new URL('https://wsrv.nl/');
  newURL.searchParams.set('url', props.url);
  newURL.searchParams.set('output', 'wepb');
  newURL.searchParams.set('q', '100');
  newURL.searchParams.set('w', `${props.width}`);
  newURL.searchParams.set('h', `${props.height}`);
  newURL.searchParams.set('fit', 'cover');
  newURL.searchParams.set('maxage', '1d');

  return newURL.toString();
});
</script>
